import { invoke } from '@tauri-apps/api/core'

let _dbReady = false

async function writeToSqlite(level, component, message) {
  try {
    if (!_dbReady) {
      const { usePosDatabase } = await import('~/composables/usePosDatabase.js')
      const { isDbReady } = usePosDatabase()
      if (isDbReady.value) _dbReady = true
      else return
    }
    const { usePosDatabase } = await import('~/composables/usePosDatabase.js')
    const { saveAppLog } = usePosDatabase()
    await saveAppLog(level, component, message)
  } catch {}
}

class UnifiedLogger {
  constructor(component) {
    this.component = component
    this.isTauri = false
    this.checkTauri()
  }

  async checkTauri() {
    try {
      await invoke('get_device_type')
      this.isTauri = true
    } catch {
      this.isTauri = false
    }
  }

  async _write(level, args) {
    const timestamp = new Date().toISOString()
    const message = args.map(arg =>
      typeof arg === 'object' ? JSON.stringify(arg, null, 2) : String(arg)
    ).join(' ')

    if (this.isTauri) {
      try {
        await invoke('write_app_log', {
          level,
          component: this.component,
          message,
          timestamp
        })
      } catch (err) {
      }
    }

    writeToSqlite(level, this.component, message)

    const consoleMethod = level === 'ERROR' ? 'error' :
                         level === 'WARN' ? 'warn' :
                         level === 'INFO' ? 'info' : 'log'
    console[consoleMethod](`[${timestamp}] [${this.component}]`, ...args)
  }

  debug(...args) {
    this._write('DEBUG', args)
  }

  info(...args) {
    this._write('INFO', args)
  }

  warn(...args) {
    this._write('WARN', args)
  }

  error(...args) {
    this._write('ERROR', args)
  }

  network(method, url, status, duration) {
    this._write('INFO', [`${method} ${url} - ${status} (${duration}ms)`])
  }

  metric(name, value, unit = '') {
    this._write('INFO', [`${name}: ${value}${unit}`])
  }

  state(action, data) {
    this._write('DEBUG', [`${action}`, data])
  }

  withContext(context) {
    return {
      debug: (...args) => this.debug(`[${JSON.stringify(context)}]`, ...args),
      info: (...args) => this.info(`[${JSON.stringify(context)}]`, ...args),
      warn: (...args) => this.warn(`[${JSON.stringify(context)}]`, ...args),
      error: (...args) => this.error(`[${JSON.stringify(context)}]`, ...args)
    }
  }
}

export function useLogger(component) {
  return new UnifiedLogger(component)
}
